import { ChipProps, Chip as MuiChip } from '@mui/material';

const Chip = (props: ChipProps): JSX.Element => <MuiChip {...props} />;

export default Chip;
